import {
  classNamesFunction,
  IStyle,
} from '@fluentui/react';

export interface ISelfHelpAlchemyStyles {
  articleDiv: IStyle;
  socView: IStyle;
}

export const getSelfHelpAlchemyStyles = () => {
  return {
    articleDiv: {
      marginBottom: '14px',
    },
    socView: {
      b: {
        /* Alchemy returns B tag for button, We dont want to show it in SOC */
        selectors: {
          '&[data-action-id]': {
            display: 'none',
          },
        },
      },
    },
  };
};

export const getSelfHelpAlchemyClassNames = classNamesFunction<{}, ISelfHelpAlchemyStyles>();
